import React, { useState, useEffect, useMemo } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Modal from 'components/Tvendo/Common/ModalBase';
import { TextField } from '@material-ui/core';
// Card para producto
import CardHeader from 'components/Card/CardHeader';
import FilterArticle from 'hooks/FilterArticle';
import { Collapse } from '@material-ui/core';
import Card from 'components/Card/Card';
import { ArrowDropDown } from '@material-ui/icons';
import { wsPost } from 'services/WService';
import { wsUpdate } from 'services/WService';

function ComboDetailModal(props) {
  const { showNotify, reload } = props;
  const detail = props.model;
  
  const [checkDisplay, setCheckDisplay] = useState(true);
  const [nameArticle, setNameArticle] = useState('');
  const [dataChanging, setDataChanging] = useState({});

  function setOpen() {
    props.setOpen({ open: false });
    setNameArticle('');
  }

  async function onSave(data) {
    let reqData = { Quantity: data.Quantity };
    let req;
    if (!('id' in detail)) {
      if (!dataChanging.logi_product_id) {
        showNotify('Seleccione un producto', 'info');
        throw new Error('Seleccione un producto');
      }
      reqData.detail_product_id = dataChanging.logi_product_id;
      console.log('aqui el rich', detail);
      req = await wsPost(`logi/product/${detail.father_product_id}/detail`, reqData);
    } else {
      req = await wsUpdate(
        `logi/product/${detail.father_product_id}/detail/${detail.ChildNum}`,
        reqData,
      );
    }
    if(!!req.success){
      showNotify(req.message);
      reload();
    }else{
      showNotify(req.message, 'error');
    }
  }

  return (
    <Modal
      title={`${'id' in detail ? 'Actualización' : 'Creación'} de detalle de combo`}
      model={props.model}
      setOpen={setOpen}
      showNotify={showNotify}
      entity={''}
      onSubmit={onSave}
    >
      {!!detail.id ? (
        <GridContainer>
          <GridItem xs={6}>
            <h6>Producto</h6>
            <h5>
              ({detail.Code}) {detail.ItemName}
            </h5>
          </GridItem>
        </GridContainer>
      ) : (
        <Card style={{ margin: 0, marginTop: '20px' }}>
          <CardHeader
            style={{ cursor: 'pointer', alignItems: 'center' }}
            onClick={() => {
              setCheckDisplay((prev) => !prev);
            }}
            icon
          >
            <h4
              style={{
                color: 'black',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
              }}
            >
              {nameArticle === '' ? 'Selecciona producto' : nameArticle}
              <ArrowDropDown />
            </h4>
          </CardHeader>
          <Collapse in={checkDisplay} key={1}>
            <div
              elevation={4}
              style={{
                padding: '10px',
                margin: 'auto',
                marginBottom: '8px !important',
                width: '100%',
              }}
            >
              <FilterArticle
                productFilter={{ base_business_partner_id: detail.base_business_partner_id }}
                fullWidth={true}
                article
                setNameArticle={setNameArticle}
                setDataChanging={setDataChanging}
                dataChanging={dataChanging}
                required
              />
            </div>
          </Collapse>
        </Card>
      )}

      <TextField
        name="Quantity"
        label="Cantidad"
        fullWidth
        type="number"
        margin="normal"
        defaultValue={detail.Quantity || 0}
        inputProps={{
          min: 1,
        }}
        required
      />
    </Modal>
  );
}

export default ComboDetailModal;
